<template>
  <div class="shop-logo">
    <div class="shop-image">
      <img :src="shop.image" :alt="shop.name">
    </div>
    <noindex>
      <button class="shop-favorites" @click="addFavorite()">
        <icon-base :iconColor="favorite ? '#3c91e6' : 'currentColor'">
          <icon-heart-outline v-if="!favorite"/>
          <icon-heart v-if="favorite"/>
        </icon-base>
        <span v-if="!favorite">{{ $t('В избранное') }}</span>
        <span v-if="favorite">{{ $t('Добавлено в избранное') }}</span>
      </button>
    </noindex>
  </div>
</template>

<script>
import IconBase from '../IconBase.vue';
import IconHeart from '../icons/IconHeart.vue';
import IconHeartOutline from '../icons/IconHeartOutline.vue';

export default {
  name: 'shop-logo',

  components: {
    IconBase,
    IconHeart,
    IconHeartOutline
  },

  props: {
    shop: Object
  },

  data() {
    return {
      favorite: false
    };
  },

  methods: {
    addFavorite() {
      this.favorite = true;
      window.ga('send', 'event', 'favorite', this.shop.slug);
    }
  }
};
</script>

<style scoped>
.shop-logo {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  height: 240px;
  background-color: #ffffff;
  border: 1px solid #dbdce1;
  border-radius: 3px;
}

.shop-image {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
}

.shop-image img {
  max-width: 100%;
  max-height: 100%;
}

.shop-favorites {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 7px 14px;
  text-align: center;
  font-size: 13px;
  color: #868993;
  border: none;
  border-top: 1px solid #dbdce1;
  background: transparent;
  cursor: pointer;
}

.shop-favorites svg {
  color: #dbdce1;
  margin-right: 4px;
}

.shop-favorites:hover svg {
  color: #3c91e6;
}

@media (max-width: 1023px) {
  .shop-logo {
    width: 210px;
    height: 195px;
  }
}

@media (max-width: 767px) {
  .shop-logo {
    width: 90px;
    height: 120px;
  }

  .shop-favorites {
    padding: 3px;
  }

  .shop-favorites span {
    display: none;
  }
}
</style>
